import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { BufferAttribute } from './BufferAttribute.js';

var InstancedBufferAttribute = /*#__PURE__*/function (_BufferAttribute) {
  _inheritsLoose(InstancedBufferAttribute, _BufferAttribute);

  function InstancedBufferAttribute(array, itemSize, normalized, meshPerAttribute) {
    var _this;

    if (meshPerAttribute === void 0) {
      meshPerAttribute = 1;
    }

    if (typeof normalized === 'number') {
      meshPerAttribute = normalized;
      normalized = false;
      console.error('THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.');
    }

    _this = _BufferAttribute.call(this, array, itemSize, normalized) || this;
    _this.meshPerAttribute = meshPerAttribute;
    return _this;
  }

  var _proto = InstancedBufferAttribute.prototype;

  _proto.copy = function copy(source) {
    _BufferAttribute.prototype.copy.call(this, source);

    this.meshPerAttribute = source.meshPerAttribute;
    return this;
  };

  _proto.toJSON = function toJSON() {
    var data = _BufferAttribute.prototype.toJSON.call(this);

    data.meshPerAttribute = this.meshPerAttribute;
    data.isInstancedBufferAttribute = true;
    return data;
  };

  return InstancedBufferAttribute;
}(BufferAttribute);

InstancedBufferAttribute.prototype.isInstancedBufferAttribute = true;
export { InstancedBufferAttribute };